<!-- Header ------------------------------------------------>
<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<div
	*ngIf="modalConfig"
	class="modal-header confirm-modal-header"
	style.border-color="var({{ modalConfig.style.color }})"
>
	<span
		class="confirm-modal-icon"
		[style.--confirm-accent]="'var(' + modalConfig.style.color + ')'"
		aria-hidden="true"
	>
		<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
		<ng-fa-icon
			class="d-inline-flex"
			[icon]="modalConfig.style.icon.name"
			[iconStyle]="modalConfig.style.icon.style"
			style.color="var({{ modalConfig.style.color }})"
		></ng-fa-icon>
	</span>
	<h5 class="modal-title">
		{{ modalContent?.title }}
	</h5>
</div>

<!-- Body --------------------------------------------------->

<div class="modal-body confirm-modal-body">
	<div class="conf-modal-message">
		<div
			[innerHtml]="modalContent?.message"
		></div>
	</div>
</div>

<!-- Footer ------------------------------------------------->
<div class="modal-footer confirm-modal-footer">
	<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
	<button
		type="button"
		class="btn confirm-modal-action"
		*ngFor="let button of modalConfig?.buttons"
		[style.--confirm-button-color]="'var(' + button.color + ')'"
		(click)="emitButtonAction(button?.actionCode!)"
	>
		{{ button.buttonText }}
	</button>
</div>
